<template>
  <ul v-if="rates.length > 0">
    <li v-for="rate in rates" :key="rate.id" class="shipping-option">
      <ShippingOption :rate="rate" :weight="weight" />
    </li>
  </ul>
  <p v-else-if="!loading">Sorry we don't ship to your destination</p>
</template>

<script>
import { mapState } from "vuex";
import ShippingOption from "@/components/product-display/ShippingOption.vue";

export default {
  name: "ShippingRates",
  components: {
    ShippingOption,
  },
  props: {
    weight: {
      type: Number,
      default: 0.2,
    },
  },
  data() {
    return {
      rates: [],
      loading: true,
      submitted: false,
    };
  },
  computed: {
    ...mapState("app", ["userCountry"]),
  },
  watch: {
    userCountry(newVal, oldVal) {
      if (oldVal === null && newVal !== null) {
        this.getShippingRates();
      }
    },
  },
  mounted() {
    this.getShippingRates();
  },
  methods: {
    async getShippingRates() {
      if (this.submitted) {
        return;
      }

      this.submitted = true;
      this.loading = true;

      if (!this.userCountry) {
        return;
      }

      const response = await fetch(
        `${process.env.RATANDBOA_NODE_APP_URL}/shipping-rates?usersCountry=${this.userCountry}`
      );

      if (!response.ok) {
        this.loading = false;
        return;
      }

      const json = await response.json();

      this.rates = json;
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.shipping-option {
  margin-bottom: 20px;

  &__name {
    display: block;
    font-size: 12px;
    font-weight: 600;
    margin-bottom: 5px;
  }

  &__info {
    display: block;
  }
}
</style>
